export default __webpack_public_path__ + "static/media/FallBacklogo.bc7f3641.png";